import { Link } from "@tanstack/react-router";
import { Facebook, Instagram, Phone, Mail, MapPin } from "lucide-react";
import { LOGO } from "@/lib/images";
import { CookieSettingsLink } from "@/components/analytics/CookieConsent";
import { SITE } from "@/lib/site";

export function SiteFooter() {
  return (
    <footer className="mt-24 border-t border-border bg-secondary/50">
      <div className="container-page py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO.src} srcSet={LOGO.srcSet} sizes="48px" alt="" className="h-12 w-12 object-contain" width={48} height={48} loading="lazy" decoding="async" />
            <div>
              <div className="font-display font-bold text-primary">N S Physiotherapy</div>
              <div className="text-xs text-muted-foreground">{SITE.tagline}</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-muted-foreground">
            In clinic and mobile physiotherapy across Centurion, Midrand, Pretoria and Johannesburg.
          </p>
          <div className="mt-4 flex gap-3">
            <a href={SITE.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-background border border-border text-primary hover:bg-accent"><Facebook className="h-4 w-4" /></a>
            <a href={SITE.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-background border border-border text-primary hover:bg-accent"><Instagram className="h-4 w-4" /></a>
          </div>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold text-primary">Services</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/services/$slug" params={{ slug: "back-pain-physiotherapy" }} className="text-muted-foreground hover:text-primary">Back Pain</Link></li>
            <li><Link to="/services/$slug" params={{ slug: "neck-pain-physiotherapy" }} className="text-muted-foreground hover:text-primary">Neck Pain</Link></li>
            <li><Link to="/services/$slug" params={{ slug: "sports-injury-physiotherapy" }} className="text-muted-foreground hover:text-primary">Sports Injuries</Link></li>
            <li><Link to="/services/$slug" params={{ slug: "post-operative-rehabilitation" }} className="text-muted-foreground hover:text-primary">Post Operative Rehab</Link></li>
            <li><Link to="/services/$slug" params={{ slug: "stroke-rehabilitation" }} className="text-muted-foreground hover:text-primary">Stroke Rehabilitation</Link></li>
            <li><Link to="/physio-at-home" className="text-muted-foreground hover:text-primary">Home Physiotherapy</Link></li>
            <li><Link to="/services/$slug" params={{ slug: "dry-needling" }} className="text-muted-foreground hover:text-primary">Dry Needling</Link></li>
            <li><Link to="/services/$slug" params={{ slug: "orthopaedic-rehabilitation" }} className="text-muted-foreground hover:text-primary">Orthopaedic Rehab</Link></li>

          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold text-primary">Explore</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/physio-at-home" className="text-muted-foreground hover:text-primary">Physio@Home</Link></li>
            <li><Link to="/medico-legal" className="text-muted-foreground hover:text-primary">Medico Legal</Link></li>
            <li><Link to="/blog" className="text-muted-foreground hover:text-primary">Blog</Link></li>
            <li><Link to="/back-and-neck-assessment" className="text-muted-foreground hover:text-primary">Free Back & Neck Check</Link></li>
            <li><Link to="/symptom-guide" className="text-muted-foreground hover:text-primary">Physio Bot</Link></li>
            <li><Link to="/booking" className="text-muted-foreground hover:text-primary">Book Appointment</Link></li>
            <li><Link to="/faqs" className="text-muted-foreground hover:text-primary">FAQs</Link></li>
            <li><Link to="/contact" className="text-muted-foreground hover:text-primary">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-semibold text-primary">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
            <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-primary" /> Shop 11, Highveld, Eco Boulevard Shopping Centre, 270 Witch Hazel Avenue, Centurion, Gauteng</li>
            <li className="flex gap-2"><Phone className="h-4 w-4 mt-0.5 shrink-0 text-primary" /> <a href={`tel:${SITE.phoneRaw}`} className="hover:text-primary">{SITE.phone}</a></li>
            <li className="flex gap-2"><Mail className="h-4 w-4 mt-0.5 shrink-0 text-primary" /> <a href={`mailto:${SITE.email}`} className="hover:text-primary break-all">{SITE.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container-page py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} N S Physiotherapy, All Rights Reserved.</span>
          <span className="flex items-center gap-3">
            <CookieSettingsLink className="hover:text-primary underline-offset-2 hover:underline" />
            <span>Designed for care, built for trust.</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
